// components/home/Hero/styles.js
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Container } from '../../../styles/components';

export const HeroWrapper = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  padding: ${props => `${props.theme.spacing['4xl']} 0`};
  background: linear-gradient(
    135deg,
    ${props => `${props.theme.colors.primary.main}08`},
    ${props => `${props.theme.colors.secondary.main}08`}
  );

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    min-height: 80vh;
  }
`;

export const HeroContainer = styled(Container)`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${props => props.theme.spacing.xxl};
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
`;

export const HeroContent = styled(motion.div)`
  text-align: center;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    text-align: left;
  }
`;

export const HeroTitle = styled(motion.h1)`
  font-size: ${props => props.theme.typography.sizes['4xl']};
  font-weight: ${props => props.theme.typography.weights.bold};
  line-height: ${props => props.theme.typography.lineHeights.tight};
  margin-bottom: ${props => props.theme.spacing.lg};
  color: ${props => props.theme.colors.text.primary};

  span {
    color: ${props => props.theme.colors.primary.main};
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.typography.sizes['5xl']};
  }
`;

export const HeroDescription = styled(motion.p)`
  font-size: ${props => props.theme.typography.sizes.lg};
  color: ${props => props.theme.colors.text.secondary};
  margin-bottom: ${props => props.theme.spacing.xl};
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const ButtonGroup = styled(motion.div)`
  display: flex;
  gap: ${props => props.theme.spacing.md};
  justify-content: center;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    justify-content: flex-start;
  }
`;

export const ImageWrapper = styled(motion.div)`
  position: relative;
  border-radius: ${props => props.theme.borderRadius.xl};
  overflow: hidden;
  aspect-ratio: 4/3;
  box-shadow: ${props => props.theme.shadows.xl};
  margin-top: ${props => props.theme.spacing.xl};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      45deg,
      ${props => `${props.theme.colors.primary.main}20`},
      transparent
    );
  }
`;
